import { CALIFORNIA_STATE_CODE } from 'root-constants'

export const isCaliforniaUser = (userGeoState: string): boolean =>
  userGeoState.trim().toUpperCase() === CALIFORNIA_STATE_CODE
